import status from "../../constants/actionStatus";

const getQuizResultReducer = (
    state = {
        quizResult: {},
        isLoading: false
    },
    action = {}
) => {
    switch (action.type) {
    case "QUIZ_RESULT_REQUEST":
        return {
            status: status.PENDING,
            quizResult: {},
            isLoading: true
        };
    case "QUIZ_RESULT_SUCCESS":
        return {
            status: status.SUCCESS,
            quizResult: action.payload,
            isLoading: false
        };

    case "QUIZ_RESULT_ERORR":
        return {
            status: status.ERROR,
            isLoading: false,
            quizResult: action.payload || { error: 'An unknown error occurred' }
        };
    case "SET_QUIZ_LOADING":
        return {
            ...state,
            isLoading: action.payload,
        };
    default:
        return state;
    }
};

export default getQuizResultReducer;
